import { createContext } from 'react'

export const IconContext = createContext<{ color: string | undefined }>({
  color: undefined,
})
